import isEmpty from 'lodash/isEmpty'
import React from 'react'
import { DateTimeInput } from '@ztechapps/webui.date'
import { useContext } from './Context'
import type { DateType } from '@ztechapps/common.utils'
import { toDate } from '@ztechapps/common.utils'

export const DateValue = () => {
  const { dateType, readonly, onChange, newValue, valueType, isDynamic } = useContext()
  const [dateValue, setDateValue] = React.useState<DateType>(toDate())

  React.useEffect(() => {
    if (isEmpty(dateValue))
      if (valueType === 'date') {
        if (isDynamic(newValue)) {
          const now = toDate()
          setDateValue(now)
        } else {
          setDateValue(toDate(newValue))
        }
      }
  }, [valueType])

  return (
    <DateTimeInput
      type={dateType}
      value={dateValue}
      disabled={readonly}
      onChange={(e) => {
        const date = toDate(e)
        const value = date.toDate().toISOString()
        setDateValue(date)
        onChange(value)
      }}
    />
  )
}
